import { render, staticRenderFns } from "./packPay.vue?vue&type=template&id=4acd806f&scoped=true"
import script from "./packPay.vue?vue&type=script&lang=js"
export * from "./packPay.vue?vue&type=script&lang=js"
import style0 from "./packPay.vue?vue&type=style&index=0&id=4acd806f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd806f",
  null
  
)

export default component.exports